<template>
  <nuxt-link
    :to="link"
    class="-mx-3 block rounded-xl px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-brand-50 hover:text-brand-700 transition active:bg-brand-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
  >
    {{ label }}
  </nuxt-link>
</template>

<script setup lang="ts">
import type { ButtonProps } from 'types/button'

const { label, link } = defineProps<ButtonProps>()
</script>
